module.exports = __webpack_public_path__ + "static/media/que-hacer-en-recoleta.2d386a16.md";